"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeParticularMentions = void 0;
const calculateTotals_1 = require("../calculateTotals");
const canDoVatReverseCharge_1 = __importDefault(require("./helpers/canDoVatReverseCharge"));
const shouldBeExemptedFromVAT_1 = __importDefault(require("./helpers/shouldBeExemptedFromVAT"));
const getParticularMentionsType = ({ client, company, }) => {
    const vatReverseCharge = (0, canDoVatReverseCharge_1.default)(company, client);
    const isExemptedFromVAT = (0, shouldBeExemptedFromVAT_1.default)(client);
    const vatDoesNotApply = company.isMicro;
    if (vatReverseCharge) {
        return 'VAT_REVERSE_CHARGE';
    }
    if (isExemptedFromVAT) {
        return 'VAT_EXEMPTION';
    }
    if (vatDoesNotApply) {
        return 'VAT_DOES_NOT_APPLY';
    }
    return null;
};
const computeParticularMentions = ({ client, company, tasks, }) => {
    const taskWithTotals = tasks.map(calculateTotals_1.calculateInvoiceTaskTotals);
    const hasVat = taskWithTotals.some((task) => task.totalVatAmount !== 0);
    if (hasVat) {
        return null;
    }
    return getParticularMentionsType({
        client,
        company,
    });
};
exports.computeParticularMentions = computeParticularMentions;
